"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[611],{

/***/ 8969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ apollo_client; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get.mjs + 1 modules
var _get = __webpack_require__(5785);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(2662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(6626);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/cross-fetch/dist/browser-ponyfill.js
var browser_ponyfill = __webpack_require__(4098);
var browser_ponyfill_default = /*#__PURE__*/__webpack_require__.n(browser_ponyfill);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 8 modules
var ApolloClient = __webpack_require__(4096);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 7 modules
var inMemoryCache = __webpack_require__(5526);
// EXTERNAL MODULE: ./node_modules/apollo-upload-client/public/createUploadLink.js
var createUploadLink = __webpack_require__(9776);
var createUploadLink_default = /*#__PURE__*/__webpack_require__.n(createUploadLink);
// EXTERNAL MODULE: ./config.ts
var config = __webpack_require__(8288);
// EXTERNAL MODULE: ./xFrame4/business/TokenManager.ts
var TokenManager = __webpack_require__(1953);
;// CONCATENATED MODULE: ./xFrame4/business/GraphQlClient.ts












var GraphQlClient = /*#__PURE__*/ function(ApolloClient) {
    "use strict";
    (0,_inherits/* default */.Z)(GraphQlClient, ApolloClient);
    var _super = (0,_create_super/* default */.Z)(GraphQlClient);
    function GraphQlClient(options) {
        (0,_class_call_check/* default */.Z)(this, GraphQlClient);
        return _super.call(this, options);
    }
    var _proto = GraphQlClient.prototype;
    /**
     * Make a query.
     * 
     * @param options 
     */ _proto.query = function query(options) {
        var _this = this;
        var _this1 = this, _superprop_get_query = function() {
            return (0,_get/* default */.Z)((0,_get_prototype_of/* default */.Z)(GraphQlClient.prototype), "query", _this);
        };
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var tokenManager, token;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tokenManager = new TokenManager/* default */.Z();
                        token = null;
                        if (!(typeof localStorage != "undefined")) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 5;
                        return tokenManager.getTokenFromLocalStorage();
                    case 5:
                        token = _ctx.sent;
                    case 6:
                        // Add Authorization headers to the context.
                        if (token != null) {
                            options.context = {
                                headers: {
                                    Authorization: "JWT " + token
                                }
                            };
                        }
                        return _ctx.abrupt("return", _superprop_get_query().call(_this1, options));
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Make a mutation.
     * 
     * @param options 
     */ _proto.mutate = function mutate(options) {
        var _this = this;
        var _this1 = this, _superprop_get_mutate = function() {
            return (0,_get/* default */.Z)((0,_get_prototype_of/* default */.Z)(GraphQlClient.prototype), "mutate", _this);
        };
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var tokenManager, token;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tokenManager = new TokenManager/* default */.Z();
                        token = null;
                        if (!(typeof localStorage != "undefined")) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 5;
                        return tokenManager.getTokenFromLocalStorage();
                    case 5:
                        token = _ctx.sent;
                    case 6:
                        // Add Authorization headers to the context.
                        if (token != undefined) {
                            /* @ts-ignore */ options.context = {
                                headers: {
                                    Authorization: "JWT " + token
                                }
                            };
                        }
                        return _ctx.abrupt("return", _superprop_get_mutate().call(_this1, options));
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GraphQlClient;
}(ApolloClient/* ApolloClient */.f);
// Disable cache.
var defaultOptions = {
    watchQuery: {
        fetchPolicy: "no-cache",
        errorPolicy: "ignore"
    },
    query: {
        fetchPolicy: "no-cache",
        errorPolicy: "all"
    }
};
// Create client.
var client = new GraphQlClient({
    //link: new HttpLink({ uri: config.apiUrl, fetch }),
    link: createUploadLink_default()({
        uri: config/* default.apiUrl */.Z.apiUrl,
        fetch: (browser_ponyfill_default())
    }),
    cache: new inMemoryCache/* InMemoryCache */.h(),
    defaultOptions: defaultOptions
});
/* harmony default export */ var business_GraphQlClient = (client);

;// CONCATENATED MODULE: ./graphql/apollo-client.ts

/* harmony default export */ var apollo_client = (business_GraphQlClient);


/***/ }),

/***/ 2705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AT": function() { return /* binding */ VerifyAccountDocument; },
/* harmony export */   "Cx": function() { return /* binding */ LoginFacebookUserDocument; },
/* harmony export */   "E8": function() { return /* binding */ RegisterUserDocument; },
/* harmony export */   "Gr": function() { return /* binding */ ExhibitionCategoryStatus; },
/* harmony export */   "LU": function() { return /* binding */ SendPasswordResetEmailDocument; },
/* harmony export */   "Qh": function() { return /* binding */ PortfolioItemType; },
/* harmony export */   "Zc": function() { return /* binding */ PortfolioItemStatus; },
/* harmony export */   "aL": function() { return /* binding */ LoginGoogleUserDocument; },
/* harmony export */   "en": function() { return /* binding */ MeDocument; },
/* harmony export */   "fD": function() { return /* binding */ RefreshUserTokenDocument; },
/* harmony export */   "gY": function() { return /* binding */ ExhibitionStatus; },
/* harmony export */   "hu": function() { return /* binding */ ResendActivationEmailDocument; },
/* harmony export */   "tJ": function() { return /* binding */ PortfolioCategoryStatus; },
/* harmony export */   "tV": function() { return /* binding */ LoginUserDocument; },
/* harmony export */   "ti": function() { return /* binding */ PageStatus; },
/* harmony export */   "vK": function() { return /* binding */ PasswordResetDocument; },
/* harmony export */   "vg": function() { return /* binding */ CheckPasswordDocument; },
/* harmony export */   "yh": function() { return /* binding */ VerifyUserTokenDocument; }
/* harmony export */ });
/* unused harmony exports EmailTemplateTypeOfEmailTemplate, PageInfoDetailsFragmentFragmentDoc, UserDetailsFragmentFragmentDoc, useLoginFacebookUserMutation, useLoginGoogleUserMutation, useLoginUserMutation, usePasswordResetMutation, useRefreshUserTokenMutation, useRegisterUserMutation, useResendActivationEmailMutation, useSendPasswordResetEmailMutation, SetPermissionsForGroupDocument, useSetPermissionsForGroupMutation, useVerifyAccountMutation, useVerifyUserTokenMutation, useCheckPasswordQuery, useCheckPasswordLazyQuery, ListPermissionsDocument, useListPermissionsQuery, useListPermissionsLazyQuery, useMeQuery, useMeLazyQuery */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7283);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageInfoDetailsFragment on PageInfo {\n  hasNextPage\n  hasPreviousPage\n  startCursor\n  endCursor\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment UserDetailsFragment on UserNode {\n  id\n  pk\n  username\n  email\n  verified\n  isStaff\n  isActive\n  dateJoined\n  firstName\n  lastName\n  nickname\n  name\n  facebookLoginId\n  googleLoginId\n}\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation LoginFacebookUser($facebookLoginId: String!, $email: String) {\n  loginFacebookUser(facebookLoginId: $facebookLoginId, email: $email) {\n    success\n    token\n    refreshToken\n    user {\n      ...UserDetailsFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation LoginGoogleUser($googleLoginId: String!, $email: String) {\n  loginGoogleUser(googleLoginId: $googleLoginId, email: $email) {\n    success\n    token\n    refreshToken\n    user {\n      ...UserDetailsFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation LoginUser($email: String!, $password: String!) {\n  tokenAuth(email: $email, password: $password) {\n    success\n    token\n    refreshToken\n    user {\n      ...UserDetailsFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation PasswordReset($token: String!, $newPassword1: String!, $newPassword2: String!) {\n  passwordReset(\n    token: $token\n    newPassword1: $newPassword1\n    newPassword2: $newPassword2\n  ) {\n    success\n  }\n}\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RefreshUserToken($refreshToken: String!) {\n  refreshToken(refreshToken: $refreshToken) {\n    success\n    token\n    refreshToken\n  }\n}\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RegisterUser($email: String!, $password: String!) {\n  register(\n    email: $email\n    username: $email\n    password1: $password\n    password2: $password\n  ) {\n    success\n    token\n    refreshToken\n  }\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ResendActivationEmail($email: String!) {\n  resendActivationEmail(email: $email) {\n    success\n  }\n}\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation SendPasswordResetEmail($email: String!) {\n  sendPasswordResetEmail(email: $email) {\n    success\n  }\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation SetPermissionsForGroup($groupId: Int!, $permissionCodenames: [String]) {\n  setPermissionsForGroup(\n    groupId: $groupId\n    permissionCodenames: $permissionCodenames\n  ) {\n    success\n  }\n}\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation VerifyAccount($token: String!) {\n  verifyAccount(token: $token) {\n    success\n  }\n}\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation VerifyUserToken($token: String!) {\n  verifyToken(token: $token) {\n    success\n  }\n}\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query CheckPassword($email: String!, $password: String!) {\n  checkPassword(email: $email, password: $password)\n}\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query ListPermissions {\n  permissions {\n    codename\n    name\n  }\n}\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Me {\n  me {\n    ...UserDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var defaultOptions = {};
var EmailTemplateTypeOfEmailTemplate;
(function(EmailTemplateTypeOfEmailTemplate) {
    EmailTemplateTypeOfEmailTemplate[/** CONTACT_MESSAGE_RECEIVED */ "ContactMessageReceived"] = "CONTACT_MESSAGE_RECEIVED";
    EmailTemplateTypeOfEmailTemplate[/** TEST */ "Test"] = "TEST";
})(EmailTemplateTypeOfEmailTemplate || (EmailTemplateTypeOfEmailTemplate = {}));
var ExhibitionCategoryStatus;
(function(ExhibitionCategoryStatus) {
    ExhibitionCategoryStatus[/** DISABLED */ "Disabled"] = "DISABLED";
    ExhibitionCategoryStatus[/** ENABLED */ "Enabled"] = "ENABLED";
})(ExhibitionCategoryStatus || (ExhibitionCategoryStatus = {}));
var ExhibitionStatus;
(function(ExhibitionStatus) {
    ExhibitionStatus[/** DISABLED */ "Disabled"] = "DISABLED";
    ExhibitionStatus[/** ENABLED */ "Enabled"] = "ENABLED";
})(ExhibitionStatus || (ExhibitionStatus = {}));
var PageStatus;
(function(PageStatus) {
    PageStatus[/** DRAFT */ "Draft"] = "DRAFT";
    PageStatus[/** PUBLISHED */ "Published"] = "PUBLISHED";
})(PageStatus || (PageStatus = {}));
var PortfolioCategoryStatus;
(function(PortfolioCategoryStatus) {
    PortfolioCategoryStatus[/** DISABLED */ "Disabled"] = "DISABLED";
    PortfolioCategoryStatus[/** ENABLED */ "Enabled"] = "ENABLED";
})(PortfolioCategoryStatus || (PortfolioCategoryStatus = {}));
var PortfolioItemStatus;
(function(PortfolioItemStatus) {
    PortfolioItemStatus[/** DISABLED */ "Disabled"] = "DISABLED";
    PortfolioItemStatus[/** ENABLED */ "Enabled"] = "ENABLED";
})(PortfolioItemStatus || (PortfolioItemStatus = {}));
var PortfolioItemType;
(function(PortfolioItemType) {
    PortfolioItemType[/** IMAGE */ "Image"] = "IMAGE";
    PortfolioItemType[/** VIDEO */ "Video"] = "VIDEO";
})(PortfolioItemType || (PortfolioItemType = {}));
var PageInfoDetailsFragmentFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var UserDetailsFragmentFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var LoginFacebookUserDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2(), UserDetailsFragmentFragmentDoc);
/**
 * __useLoginFacebookUserMutation__
 *
 * To run a mutation, you first call `useLoginFacebookUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginFacebookUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginFacebookUserMutation, { data, loading, error }] = useLoginFacebookUserMutation({
 *   variables: {
 *      facebookLoginId: // value for 'facebookLoginId'
 *      email: // value for 'email'
 *   },
 * });
 */ function useLoginFacebookUserMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(LoginFacebookUserDocument, options);
}
var LoginGoogleUserDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3(), UserDetailsFragmentFragmentDoc);
/**
 * __useLoginGoogleUserMutation__
 *
 * To run a mutation, you first call `useLoginGoogleUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginGoogleUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginGoogleUserMutation, { data, loading, error }] = useLoginGoogleUserMutation({
 *   variables: {
 *      googleLoginId: // value for 'googleLoginId'
 *      email: // value for 'email'
 *   },
 * });
 */ function useLoginGoogleUserMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(LoginGoogleUserDocument, options);
}
var LoginUserDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4(), UserDetailsFragmentFragmentDoc);
/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */ function useLoginUserMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(LoginUserDocument, options);
}
var PasswordResetDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *   },
 * });
 */ function usePasswordResetMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(PasswordResetDocument, options);
}
var RefreshUserTokenDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());
/**
 * __useRefreshUserTokenMutation__
 *
 * To run a mutation, you first call `useRefreshUserTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshUserTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshUserTokenMutation, { data, loading, error }] = useRefreshUserTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */ function useRefreshUserTokenMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(RefreshUserTokenDocument, options);
}
var RegisterUserDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7());
/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */ function useRegisterUserMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(RegisterUserDocument, options);
}
var ResendActivationEmailDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject8());
/**
 * __useResendActivationEmailMutation__
 *
 * To run a mutation, you first call `useResendActivationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendActivationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendActivationEmailMutation, { data, loading, error }] = useResendActivationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */ function useResendActivationEmailMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(ResendActivationEmailDocument, options);
}
var SendPasswordResetEmailDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject9());
/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */ function useSendPasswordResetEmailMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(SendPasswordResetEmailDocument, options);
}
var SetPermissionsForGroupDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject10());
/**
 * __useSetPermissionsForGroupMutation__
 *
 * To run a mutation, you first call `useSetPermissionsForGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPermissionsForGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPermissionsForGroupMutation, { data, loading, error }] = useSetPermissionsForGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      permissionCodenames: // value for 'permissionCodenames'
 *   },
 * });
 */ function useSetPermissionsForGroupMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(SetPermissionsForGroupDocument, options);
}
var VerifyAccountDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject11());
/**
 * __useVerifyAccountMutation__
 *
 * To run a mutation, you first call `useVerifyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAccountMutation, { data, loading, error }] = useVerifyAccountMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */ function useVerifyAccountMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(VerifyAccountDocument, options);
}
var VerifyUserTokenDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject12());
/**
 * __useVerifyUserTokenMutation__
 *
 * To run a mutation, you first call `useVerifyUserTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserTokenMutation, { data, loading, error }] = useVerifyUserTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */ function useVerifyUserTokenMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(VerifyUserTokenDocument, options);
}
var CheckPasswordDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject13());
/**
 * __useCheckPasswordQuery__
 *
 * To run a query within a React component, call `useCheckPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPasswordQuery({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */ function useCheckPasswordQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CheckPasswordDocument, options);
}
function useCheckPasswordLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CheckPasswordDocument, options);
}
var ListPermissionsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject14());
/**
 * __useListPermissionsQuery__
 *
 * To run a query within a React component, call `useListPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPermissionsQuery({
 *   variables: {
 *   },
 * });
 */ function useListPermissionsQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ListPermissionsDocument, options);
}
function useListPermissionsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ListPermissionsDocument, options);
}
var MeDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject15(), UserDetailsFragmentFragmentDoc);
/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */ function useMeQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(MeDocument, options);
}
function useMeLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(MeDocument, options);
}


/***/ }),

/***/ 6410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useAppActionDispatch; },
/* harmony export */   "k": function() { return /* binding */ useAppStateSelector; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);

// Use throughout your app instead of plain `useDispatch` and `useSelector`
var useAppActionDispatch = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0;
var useAppStateSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;


/***/ }),

/***/ 628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vs": function() { return /* binding */ BusinessEntityField; },
/* harmony export */   "v2": function() { return /* binding */ EntityManager; }
/* harmony export */ });
/* unused harmony export BusinessEntity */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7283);
/* harmony import */ var _graphql_apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8969);
/* harmony import */ var _xFrame4_common_Functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8658);







var BusinessEntity = /*#__PURE__*/ function() {
    "use strict";
    function BusinessEntity() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, BusinessEntity);
        /** The primary key. */ this.id = null;
        /** A unique ID to identify the entity even if it has not been saved. */ this.uniqueId = (0,_xFrame4_common_Functions__WEBPACK_IMPORTED_MODULE_3__/* .uniqueId */ .EL)();
    }
    var _proto = BusinessEntity.prototype;
    /**
     * Fill the entity's fields from a GraphQL object.
     * 
     * @param graphQlObject An object from the GraphQL API response.
     */ _proto.copyFromGraphQL = function copyFromGraphQL(graphQlObject) {
        var cls = this["constructor"]; // https://stackoverflow.com/questions/20851358/access-child-class-static-members-from-base-class
        cls.manager.copyFromGraphQL(this, graphQlObject);
    };
    /**
     * Saves the entity as a new one or updates an existing via GraphQL.
     * 
     * @returns True if succeeded, false if not.
     */ _proto.save = function save() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var cls;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        cls = _this["constructor"];
                        _ctx.next = 3;
                        return cls.manager.saveEntity(_this);
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Deletes the entity via GraphQL.
     * 
     * @returns True if succeeded, false if not.
     */ _proto.delete = function _delete() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var cls;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        cls = _this["constructor"];
                        _ctx.next = 3;
                        return cls.manager.deleteEntity(_this);
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Create a copy of the entity.
     */ _proto.copy = function copy() {
        var cls = this["constructor"];
        var copy1 = new cls();
        return Object.assign(copy1, this);
    };
    /** 
     * Convert the entity to a serializable JSON object. 
     */ _proto.toJson = function toJson() {
        var object = this.copy();
        return JSON.parse(JSON.stringify(object));
    };
    /**
     * Convert an array of entities to a serializable JSON object. 
     * Useful with Next.js getStaticProps serialize/deserialize.
     * 
     * @param entities An array of BusinessEntity objects.
     */ BusinessEntity.arrayToJson = function arrayToJson(entities) {
        return entities.map(function(entity) {
            return entity.toJson();
        });
    };
    /**
     * Create an entity from a GraphQL object. Use this if the method on the manager is not convenient.
     * 
     * @param graphQlObject An object from the GraphQL API response.
     */ BusinessEntity.createFromGraphQL = function createFromGraphQL(graphQlObject) {
        var entity = new this();
        entity.copyFromGraphQL(graphQlObject);
        return entity;
    };
    /**
     * Create a BusinessEntity from a JSON object (or from any object as a matter of fact). 
     * The structure needs to be the same as of a BusinessEntity. 
     * For now this is an alias for createFromGraphQL.
     * Useful with Next.js getStaticProps serialize/deserialize.
     * 
     * @param jsonObject A BusinessEntity JSON object that was created with toJson().
     */ BusinessEntity.createFromJson = function createFromJson(jsonObject) {
        return this.createFromGraphQL(jsonObject);
    };
    /**
     * Create a list of BusinessEntity objects from a list of JSON objects.
     * Uses createFromJson.
     * Useful with Next.js getStaticProps serialize/deserialize.
     * 
     * @param jsonObjects 
     */ BusinessEntity.createArrayFromJson = function createArrayFromJson(jsonObjects) {
        var _this = this;
        return jsonObjects.map(function(jsonObject) {
            return _this.createFromGraphQL(jsonObject);
        });
    };
    /**
     * Make a copy of an array of entities.
     * 
     * @param entities 
     */ BusinessEntity.copyArray = function copyArray(entities) {
        return entities.map(function(entity) {
            return entity.copy();
        });
    };
    return BusinessEntity;
}();
/**
 * Represents an entity field. The field data connects the BusinessEntity with GraphQL and D
 */ var BusinessEntityField = /*#__PURE__*/ function() {
    "use strict";
    function BusinessEntityField(params) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, BusinessEntityField);
        this.name = params.name;
        var _inputProperty;
        this.inputProperty = (_inputProperty = params.inputProperty) !== null && _inputProperty !== void 0 ? _inputProperty : params.name;
        var _isInFieldDetails;
        this.isInFieldDetails = (_isInFieldDetails = params.isInFieldDetails) !== null && _isInFieldDetails !== void 0 ? _isInFieldDetails : true;
        var _isInput;
        this.isInput = (_isInput = params.isInput) !== null && _isInput !== void 0 ? _isInput : true;
        this.inputName = params.inputName;
        var _isRequiredInput;
        this.isRequiredInput = (_isRequiredInput = params.isRequiredInput) !== null && _isRequiredInput !== void 0 ? _isRequiredInput : false;
        var _isArrayInput;
        this.isArrayInput = (_isArrayInput = params.isArrayInput) !== null && _isArrayInput !== void 0 ? _isArrayInput : false;
        var _protectStringNumber;
        this.protectStringNumber = (_protectStringNumber = params.protectStringNumber) !== null && _protectStringNumber !== void 0 ? _protectStringNumber : false;
        this.relatedManager = params.relatedManager;
        this.customGraphQl = params.customGraphQl;
        var _recursiveFragmentDepth;
        this.recursiveFragmentDepth = (_recursiveFragmentDepth = params.recursiveFragmentDepth) !== null && _recursiveFragmentDepth !== void 0 ? _recursiveFragmentDepth : 1;
    }
    var _proto = BusinessEntityField.prototype;
    /**
     * Get the value for this field that is used for saving the entity via the GraphQL mutation.
     * 
     * @param entity The BusinessEntity object.
     */ _proto.getInputValue = function getInputValue(entity) {
        var inputValue = null;
        if (this.inputProperty.indexOf(".") == -1) {
            if (entity[this.inputProperty] !== undefined) inputValue = entity[this.inputProperty];
        } else {
            var fieldSplits = this.inputProperty.split(".");
            var memberObject = entity;
            if (!this.isArrayInput) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Simple composed field (eg: page.id)
                    for(var _iterator = fieldSplits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fieldSplit = _step.value;
                        memberObject = memberObject[fieldSplit];
                        if (memberObject === null || memberObject === undefined) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else {
                var _loop = function(i) {
                    if (i < fieldSplits.length - 1) {
                        memberObject = memberObject[fieldSplits[i]];
                    } else {
                        memberObject = memberObject.map(function(m) {
                            return m[fieldSplits[i]];
                        });
                    }
                    if (memberObject === null) return "break";
                };
                // Array composed field (eg: an array of pages.id, ie: the ID of each page)
                for(var i = 0; i < fieldSplits.length; i++){
                    var _ret = _loop(i);
                    if (_ret === "break") break;
                }
            }
            if (memberObject !== undefined) inputValue = memberObject;
        }
        // Check if the value is required
        if (this.isRequiredInput && inputValue === null) {
            throw new Error("Required variable ".concat(this.name, " has no value set."));
        }
        return inputValue;
    };
    return BusinessEntityField;
}();
/**
 * Manages the data flow between the GraphQL API and the BusinessEntity object.
 */ var EntityManager = /*#__PURE__*/ function() {
    "use strict";
    function EntityManager(parameters) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, EntityManager);
        /** The fields of the entity. These field settings connect BusinessEntity with GraphQL and Django. */ this.fields = [];
        this.name = parameters.name;
        this.createEntity = parameters.createEntity;
        this.fields = parameters.fields.map(function(constructorInput) {
            return new BusinessEntityField(constructorInput);
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var field = _step.value;
                if (field.relatedManager == "self") {
                    field.relatedManager = this;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.graphQlQueryAlias = parameters.graphQlQueryAlias;
        var _graphQlSaveAlias;
        this.graphQlSaveAlias = (_graphQlSaveAlias = parameters.graphQlSaveAlias) !== null && _graphQlSaveAlias !== void 0 ? _graphQlSaveAlias : "save" + this.name;
        var _graphQlInputAlias;
        this.graphQlInputAlias = (_graphQlInputAlias = parameters.graphQlInputAlias) !== null && _graphQlInputAlias !== void 0 ? _graphQlInputAlias : this.name + "Input";
        var _graphQlDeleteAlias;
        this.graphQlDeleteAlias = (_graphQlDeleteAlias = parameters.graphQlDeleteAlias) !== null && _graphQlDeleteAlias !== void 0 ? _graphQlDeleteAlias : "delete" + this.name;
        var _graphQlExtraFragments;
        this.graphQlExtraFragments = (_graphQlExtraFragments = parameters.graphQlExtraFragments) !== null && _graphQlExtraFragments !== void 0 ? _graphQlExtraFragments : [];
        var _hasTotalCount;
        this.hasTotalCount = (_hasTotalCount = parameters.hasTotalCount) !== null && _hasTotalCount !== void 0 ? _hasTotalCount : true;
    }
    var _proto = EntityManager.prototype;
    /**
     * Fill the entity's fields from a GraphQL object.
     * 
     * @param entity The entity.
     * @param graphQlObject An object from the GraphQL API response.
     */ _proto.copyFromGraphQL = function copyFromGraphQL(entity, graphQlObject) {
        // Copy the ID
        if (graphQlObject.id != undefined) {
            entity.id = isNaN(graphQlObject.id) ? graphQlObject.id : parseInt(graphQlObject.id);
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Copy the fields
            for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var field = _step.value;
                if (field.isInFieldDetails) {
                    var graphQlFieldValue = void 0;
                    if (field.relatedManager == undefined) {
                        graphQlFieldValue = graphQlObject[field.name];
                        // Check string number (eg: decimals are sent by Graphene as strings, and they need to be transformed to numbers)
                        if (!field.protectStringNumber) {
                            if (typeof graphQlFieldValue == "string" && graphQlFieldValue != "" && !isNaN(graphQlFieldValue)) graphQlFieldValue = parseFloat(graphQlFieldValue);
                        }
                    } else {
                        if (!Array.isArray(graphQlObject[field.name])) {
                            // A single entity
                            var relatedEntity = graphQlObject[field.name];
                            if (relatedEntity != null) {
                                graphQlFieldValue = field.relatedManager.createFromGraphQL(relatedEntity);
                            } else {
                                graphQlFieldValue = null;
                            }
                        } else {
                            // A list of entities
                            var relatedEntities = [];
                            var gqlEntities = graphQlObject[field.name];
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = gqlEntities[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var gqlEntity = _step1.value;
                                    var relatedEntity1 = field.relatedManager.createFromGraphQL(gqlEntity);
                                    relatedEntities.push(relatedEntity1);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            graphQlFieldValue = relatedEntities;
                        }
                    }
                    // Assign
                    //@ts-ignore
                    entity[field.name] = graphQlFieldValue;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    /**
     * Create an entity from a GraphQL object.
     * 
     * @param graphQlObject An object from the GraphQL API response.
     */ _proto.createFromGraphQL = function createFromGraphQL(graphQlObject) {
        var entity = this.createEntity();
        entity.copyFromGraphQL(graphQlObject);
        return entity;
    };
    /**
     * Load the entities from a GraphQL Connection query based on the filter. The result is paginated.
     * 
     * @param filter The filters as specified in the GraphQL schema.
     * @param paging The paging data for the results.
     * @returns A paginated collection of entities.
     */ _proto.load = function load(filter, paging) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var pagingString, filterString, query, result;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        pagingString = paging ? EntityManager.createQueryPagingString(paging) : "";
                        filterString = EntityManager.createQueryFilterString(filter, pagingString);
                        query = "\n            query {    \n                ".concat(_this.graphQlQueryAlias, " ").concat(filterString, " {\n                    pageInfo {\n                        hasNextPage\n                        hasPreviousPage\n                        startCursor\n                        endCursor\n                    }\n                    ").concat(_this.hasTotalCount === true ? "totalCount" : "", "\n                    edges {\n                        node {\n                            ...").concat(_this.name, "DetailsFragment\n                        }\n                    }\n                }\n            }\n\n            ").concat(_this.buildEntityDetailsFragment(), "\n        ");
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return _graphql_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].query */ .Z.query({
                            query: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps)(query)
                        });
                    case 6:
                        result = _ctx.sent;
                        if (!(result.errors === undefined)) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", _this.createPaginatedQueryResult(result));
                    case 11:
                        console.log(result.errors.map(function(e) {
                            return e.message;
                        }));
                        console.log(query);
                        return _ctx.abrupt("return", null);
                    case 14:
                        _ctx.next = 22;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log("Entity load query failed: " + _this.graphQlQueryAlias);
                        console.log(_ctx.t0.message);
                        console.log(query);
                        return _ctx.abrupt("return", null);
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    16
                ]
            ]);
        }))();
    };
    /**
     * Load entities with custom fields from a GraphQL Connection query based on the filter. The result is paginated.
     * 
     * @param customQuery The custom query.
     * @param filter The filters as specified in the GraphQL schema.
     * @param paging The paging data for the results.
     * @returns A paginated collection of entities.
     */ _proto.loadCustom = function loadCustom(customQuery, filter, paging) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var pagingString, filterString, query, result, nodes, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, edge, paginatedResult;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        pagingString = paging ? EntityManager.createQueryPagingString(paging) : "";
                        filterString = EntityManager.createQueryFilterString(filter, pagingString);
                        query = "\n            query {    \n                ".concat(_this.graphQlQueryAlias, " ").concat(filterString, " {\n                    pageInfo {\n                        hasNextPage\n                        hasPreviousPage\n                        startCursor\n                        endCursor\n                    }\n                    ").concat(_this.hasTotalCount === true ? "totalCount" : "", "\n                    edges {\n                        node {\n                            ").concat(customQuery, "\n                        }\n                    }\n                }\n            }\n        ");
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return _graphql_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].query */ .Z.query({
                            query: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps)(query)
                        });
                    case 6:
                        result = _ctx.sent;
                        if (!(result.errors === undefined)) {
                            _ctx.next = 31;
                            break;
                        }
                        nodes = [];
                        if (!(result.data[_this.graphQlQueryAlias].edges != null)) {
                            _ctx.next = 27;
                            break;
                        }
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _ctx.prev = 11;
                        for(_iterator = result.data[_this.graphQlQueryAlias].edges[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            edge = _step.value;
                            nodes.push(edge.node);
                        }
                        _ctx.next = 19;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](11);
                        _didIteratorError = true;
                        _iteratorError = _ctx.t0;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.prev = 20;
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    case 22:
                        _ctx.prev = 22;
                        if (!_didIteratorError) {
                            _ctx.next = 25;
                            break;
                        }
                        throw _iteratorError;
                    case 25:
                        return _ctx.finish(22);
                    case 26:
                        return _ctx.finish(19);
                    case 27:
                        paginatedResult = {
                            nodes: nodes,
                            paginationInfo: {
                                totalCount: result.data[_this.graphQlQueryAlias].totalCount !== undefined ? result.data[_this.graphQlQueryAlias].totalCount : -1,
                                hasPreviousPage: result.data[_this.graphQlQueryAlias].pageInfo.hasPreviousPage,
                                hasNextPage: result.data[_this.graphQlQueryAlias].pageInfo.hasNextPage,
                                startCursor: result.data[_this.graphQlQueryAlias].pageInfo.startCursor,
                                endCursor: result.data[_this.graphQlQueryAlias].pageInfo.endCursor
                            }
                        };
                        return _ctx.abrupt("return", paginatedResult);
                    case 31:
                        console.log(result.errors.map(function(e) {
                            return e.message;
                        }));
                        console.log(query);
                        return _ctx.abrupt("return", null);
                    case 34:
                        _ctx.next = 42;
                        break;
                    case 36:
                        _ctx.prev = 36;
                        _ctx.t1 = _ctx["catch"](3);
                        console.log("Entity load custom query failed: " + _this.graphQlQueryAlias);
                        console.log(_ctx.t1.message);
                        console.log(query);
                        return _ctx.abrupt("return", null);
                    case 42:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    36
                ],
                [
                    11,
                    15,
                    19,
                    27
                ],
                [
                    20,
                    ,
                    22,
                    26
                ]
            ]);
        }))();
    };
    /**
     * Builds a GraphQL query fragment for the entity.
     * https://graphql.org/learn/queries/#fragments
     * 
     * Eg:
     * fragment MenuDetailsFragment on Menu {
        ...MenuFieldsFragment
        }
     * 
     * @returns The fragment.
     */ _proto.buildEntityDetailsFragment = function buildEntityDetailsFragment() {
        var fragment = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if (fragment != "") fragment += "\n\n";
        // The EntityDetails fragment wrapper
        fragment += "fragment ".concat(this.name, "DetailsFragment on ").concat(this.name, " {") + "\n";
        // Spread the field details fragment
        fragment += "...".concat(this.name, "FieldsFragment") + "\n";
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Create recursive fragments spreads for fields that refer to the same entity
            for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var field = _step.value;
                if (field.relatedManager && field.relatedManager.name == this.name) {
                    fragment += this.buildFragmentSpreadForRecursiveField(field);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // End EntityDetails fragment wrapper
        fragment += "}" + "\n";
        // Create the fields fragment
        fragment += "\n";
        fragment += this.buildEntityFieldsFragment();
        +"\n";
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            // Create EntityDetails fragments for related entities
            for(var _iterator1 = this.fields[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var field1 = _step1.value;
                if (field1.relatedManager) {
                    if (-1 == fragment.indexOf("fragment ".concat(field1.relatedManager.name, "DetailsFragment"))) {
                        fragment = field1.relatedManager.buildEntityDetailsFragment(fragment);
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            // Add extra fragments
            for(var _iterator2 = this.graphQlExtraFragments[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var extraFragment = _step2.value;
                fragment += "\n\n";
                fragment += extraFragment;
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        return fragment;
    };
    /**
     * Build the GraphQL query part for the entity fields. 
     * Does not include fields that are referring to the same entity (GraphQL cannot spread a fragment within itself).
     * Eg:
     * 
        fragment MenuFieldsFragment on Menu {
        id
        name
        status
        location
        orderNo
        customUrl
        productCategory {
            ...ProductCategoryDetailsFragment
        }
        productCollection {
            ...ProductCollectionDetailsFragment
        }
        }
     */ _proto.buildEntityFieldsFragment = function buildEntityFieldsFragment() {
        var fragment = "";
        fragment += "fragment ".concat(this.name, "FieldsFragment on ").concat(this.name, " {") + "\n";
        fragment += "id" + "\n";
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var field = _step.value;
                if (field.isInFieldDetails) {
                    if (field.relatedManager == null) {
                        if (field.customGraphQl === undefined) {
                            // simple field
                            fragment += field.name + "\n";
                        } else {
                            // simple field with custom GraphQL
                            fragment += "".concat(field.name, " {") + "\n";
                            fragment += field.customGraphQl + "\n";
                            fragment += "}" + "\n";
                        }
                    } else if (field.relatedManager.name != this.name) {
                        // field for a related entity (spread the EntityDetailsFragment for the related entity)
                        fragment += "".concat(field.name, " {") + "\n";
                        fragment += "...".concat(field.relatedManager.name, "DetailsFragment") + "\n";
                        fragment += "}" + "\n";
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        fragment += "}";
        return fragment;
    };
    /**
     * Build a recursive fields fragment spread.
     * 
     * Eg: 
     * parent {
        ...MenuFieldsFragment
        parent {
            ...MenuFieldsFragment
            parent {
                ...MenuFieldsFragment
                parent {
                    ...MenuFieldsFragment
                }
            }   
        }
    }
     * 
     * @param field 
     * @param depth 
     */ _proto.buildFragmentSpreadForRecursiveField = function buildFragmentSpreadForRecursiveField(field, depth) {
        if (depth === undefined) depth = field.recursiveFragmentDepth;
        if (depth == 0) return "";
        var fragment = "";
        fragment += "".concat(field.name, " {") + "\n";
        fragment += "...".concat(this.name, "FieldsFragment") + "\n";
        fragment += this.buildFragmentSpreadForRecursiveField(field, depth - 1);
        fragment += "}" + "\n";
        return fragment;
    };
    /**
     * Create a paginated result object from a GraphQL query result.
     * 
     * @param result 
     * @returns The a paginated result object.
     */ _proto.createPaginatedQueryResult = function createPaginatedQueryResult(result) {
        // Create entities
        var entities = [];
        if (result.data[this.graphQlQueryAlias].edges != null) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = result.data[this.graphQlQueryAlias].edges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var edge = _step.value;
                    var entity = this.createEntity();
                    entity.copyFromGraphQL(edge.node);
                    entities.push(entity);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        // The paginated result
        var paginatedResult = {
            entities: entities,
            paginationInfo: {
                totalCount: result.data[this.graphQlQueryAlias].totalCount !== undefined ? result.data[this.graphQlQueryAlias].totalCount : -1,
                hasPreviousPage: result.data[this.graphQlQueryAlias].pageInfo.hasPreviousPage,
                hasNextPage: result.data[this.graphQlQueryAlias].pageInfo.hasNextPage,
                startCursor: result.data[this.graphQlQueryAlias].pageInfo.startCursor,
                endCursor: result.data[this.graphQlQueryAlias].pageInfo.endCursor
            }
        };
        return paginatedResult;
    };
    /**
     * Gets a single entity based on a filter.
     * 
     * @param filter The filter as specified in the GraphQL schema.
     * @returns The entity or null if nothing or more than one entities are found.
     */ _proto.get = function get(filter) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var result;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.load(filter);
                    case 2:
                        result = _ctx.sent;
                        if (!(result != null && result.entities.length == 1)) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", result.entities[0]);
                    case 7:
                        return _ctx.abrupt("return", null);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Gets a single entity with custom fields based on a filter.
     * 
     * @param customQuery The custom GraphQL query.
     * @param filter The filter as specified in the GraphQL schema.
     * @returns The entity or null if nothing or more than one entities are found.
     */ _proto.getCustom = function getCustom(customQuery, filter) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var result;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.loadCustom(customQuery, filter);
                    case 2:
                        result = _ctx.sent;
                        if (!(result != null && result.nodes.length == 1)) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", result.nodes[0]);
                    case 7:
                        return _ctx.abrupt("return", null);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Save the entity.
     * 
     * @param entity 
     * @returns True if the save was succesful.
     */ _proto.saveEntity = function saveEntity(entity) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var gqlSaveMutation, variables, success, result, graphQlObject;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        gqlSaveMutation = _this.createGraphQlSaveMutation();
                        variables = {
                            input: _this.createInputObject(entity)
                        };
                        success = false;
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return _graphql_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].mutate */ .Z.mutate({
                            mutation: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps)(gqlSaveMutation),
                            variables: variables
                        });
                    case 6:
                        result = _ctx.sent;
                        success = result.data[_this.graphQlSaveAlias].success;
                        if (success) {
                            graphQlObject = result.data[_this.graphQlSaveAlias].object;
                            entity.copyFromGraphQL(graphQlObject);
                        } else {
                            console.log("Save entity mutation not successful: " + _this.graphQlSaveAlias);
                            console.log(gqlSaveMutation);
                            console.log(JSON.stringify(variables));
                        }
                        _ctx.next = 18;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log("Error: save entity mutation failed: " + _this.graphQlSaveAlias);
                        console.log(_ctx.t0.message);
                        console.log(gqlSaveMutation);
                        console.log(JSON.stringify(variables));
                        throw "Save entity mutation failed: " + _this.graphQlSaveAlias + ". Error message: " + _ctx.t0.message;
                    case 18:
                        return _ctx.abrupt("return", success);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11
                ]
            ]);
        }))();
    };
    /**
     * Create the GraphQL save mutation for the BusinessEntity.
     * https://graphql.org/learn/queries/#mutations
     * 
     * @param entity
     */ _proto.createGraphQlSaveMutation = function createGraphQlSaveMutation() {
        var saveMutation = "";
        saveMutation += "mutation Save".concat(this.name, "($input: ").concat(this.graphQlInputAlias, "!) {") + "\n";
        saveMutation += "".concat(this.graphQlSaveAlias, "(input: $input) {") + "\n";
        saveMutation += "success" + "\n";
        saveMutation += "object {" + "\n";
        saveMutation += "...".concat(this.name, "DetailsFragment") + "\n";
        saveMutation += "}" + "\n";
        saveMutation += "}" + "\n";
        saveMutation += "}" + "\n";
        saveMutation += this.buildEntityDetailsFragment();
        return saveMutation;
    };
    /**
     * Create an input object for the GraphQL save mutation.
     * https://graphql.org/learn/schema/#input-types
     * 
     * @param entity 
     */ _proto.createInputObject = function createInputObject(entity) {
        var inputObject = {};
        inputObject.id = entity.id;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var field = _step.value;
                if (field.isInput) {
                    // Check required field
                    if (entity[field.name] === undefined && field.isRequiredInput) {
                        throw new Error("Required input field ".concat(field.name, " on ").concat(this.name, " has no value set."));
                    }
                    var _inputName;
                    // The input field name (the input field name can differ from the actual field name. Eg: region -> regionId)
                    var inputFieldName = (_inputName = field.inputName) !== null && _inputName !== void 0 ? _inputName : field.name;
                    inputObject[inputFieldName] = field.getInputValue(entity);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return inputObject;
    };
    /**
     * Deletes the entity via GraphQL.
     * 
     * @param entity The entity to delete.
     * @returns True if succeeded, false if not.
     */ _proto.deleteEntity = function deleteEntity(entity) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var idString, mutation, success, result;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        idString = "";
                        if (!(entity.id != null)) {
                            _ctx.next = 5;
                            break;
                        }
                        {
                            idString = typeof entity.id == "string" ? 'id: "'.concat(entity.id, '"') : "id: ".concat(entity.id);
                        }
                        _ctx.next = 6;
                        break;
                    case 5:
                        return _ctx.abrupt("return", false);
                    case 6:
                        mutation = "\n        mutation {\n            ".concat(_this.graphQlDeleteAlias, " (").concat(idString, ") {\n                success\n            }\n        }\n        ");
                        success = false;
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return _graphql_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].mutate */ .Z.mutate({
                            mutation: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps)(mutation)
                        });
                    case 11:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", result.data[_this.graphQlDeleteAlias].success);
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](8);
                        console.log("Error: delete entity mutation failed: " + _this.graphQlDeleteAlias);
                        console.log(mutation);
                        console.log(_ctx.t0.message);
                        throw "Delete entity mutation failed: " + _this.graphQlDeleteAlias;
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    15
                ]
            ]);
        }))();
    };
    /**
     * Create the paging arguments string for GraphQL Connection query.
     * 
     * @param paging The paging info.
     */ EntityManager.createQueryPagingString = function createQueryPagingString(paging) {
        var pagingString = "";
        if (paging === null || paging === void 0 ? void 0 : paging.first) {
            pagingString = "first: ".concat(paging.first);
            if (paging.after) pagingString += ', after: "'.concat(paging.after, '"');
        } else if (paging === null || paging === void 0 ? void 0 : paging.last) {
            pagingString = "last: ".concat(paging.last);
            if (paging.before) pagingString += ', before: "'.concat(paging.before, '"');
        }
        return pagingString;
    };
    /**
     * Create a filter string for a GraphQL Connection query.
     * 
     * @param filter The filter.
     * @param pagingString The paging string if exists.
     * @returns The filter string.
     */ EntityManager.createQueryFilterString = function createQueryFilterString(filter) {
        var pagingString = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        var filterString = "";
        if (filter !== undefined) {
            var filterArray = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(filter)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_step.value, 2), key = _value[0], value = _value[1];
                    if (value === null || value === undefined || value === "") continue;
                    var formattedValue = EntityManager.formatGraphQlParameterValue(value);
                    if (formattedValue !== null && formattedValue !== "") {
                        filterArray.push(key + ": " + formattedValue);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            filterString = filterArray.join(", ");
            if (filterString != "") {
                if (pagingString != "") {
                    // filter + paging
                    filterString = "(".concat(pagingString, ", ").concat(filterString, ")");
                } else {
                    // filter, no paging
                    filterString = "(".concat(filterString, ")");
                }
            } else {
                // paging, no filter
                if (pagingString != "") filterString = "(".concat(pagingString, ")");
            }
        }
        return filterString;
    };
    /**
     * Format a value so it can be passed to a GraphQL query.
     * Number: 100, 12.5, 12323.23
     * String: "The string"
     * Boolean: true, false
     * Array of numbers: [1, 32, 4, 56]
     * Array of strings: ["A", "B", "C"]
     * Array of booleans: [true, false, true]
     * 
     * @param value 
     * @returns The formatted value.
     */ EntityManager.formatGraphQlParameterValue = function formatGraphQlParameterValue(value) {
        if (value === null) return null;
        if (Array.isArray(value) && value.length == 0) return null;
        var formattedValue = value;
        if (typeof value == "string") {
            formattedValue = '"'.concat(value, '"');
        } else if (typeof value == "boolean") {
            formattedValue = value ? "true" : "false";
        } else if (Array.isArray(value)) {
            var arrayOfValues = value;
            if (typeof value[0] == "string") {
                arrayOfValues = value.map(function(v) {
                    return '"'.concat(v, '"');
                });
            } else if (typeof value[0] == "boolean") {
                arrayOfValues = value.map(function(v) {
                    return v ? "true" : "false";
                });
            }
            formattedValue = "[" + arrayOfValues.join(", ") + "]";
        }
        return formattedValue;
    };
    return EntityManager;
}();
/* harmony default export */ __webpack_exports__["ZP"] = (BusinessEntity);


/***/ }),

/***/ 1953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export TokenManager */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1438);
/* harmony import */ var _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8288);
/* harmony import */ var cross_fetch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4098);
/* harmony import */ var cross_fetch__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(cross_fetch__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4096);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2198);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5526);
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2705);







var TokenManager = /*#__PURE__*/ function() {
    "use strict";
    function TokenManager() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, TokenManager);
    }
    var _proto = TokenManager.prototype;
    /** Create an Apollo client for JWT purposes. */ _proto.createClient = function createClient() {
        // Disable cache.
        var defaultOptions = {
            watchQuery: {
                fetchPolicy: "no-cache",
                errorPolicy: "ignore"
            },
            query: {
                fetchPolicy: "no-cache",
                errorPolicy: "all"
            }
        };
        // Create client.
        return new _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .ApolloClient */ .f({
            link: new _apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .HttpLink */ .u({
                uri: _config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].apiUrl */ .Z.apiUrl,
                fetch: (cross_fetch__WEBPACK_IMPORTED_MODULE_2___default())
            }),
            cache: new _apollo_client__WEBPACK_IMPORTED_MODULE_7__/* .InMemoryCache */ .h(),
            defaultOptions: defaultOptions
        });
    };
    /**
     * Try to get the JWT from the local storage. 
     * If the token is expired it will try to get a new one with the refresh token.
     * 
     * @returns The token or nothing.
     */ _proto.getTokenFromLocalStorage = function getTokenFromLocalStorage() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var token, jwt;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        token = null;
                        // Try to get token from the local storage
                        token = localStorage.getItem(TokenManager.localStorageTokenIdentifier);
                        if (!(token != null)) {
                            _ctx.next = 8;
                            break;
                        }
                        jwt = _this.parseJwt(token);
                        if (!_this.isJwtExpired(jwt)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 7;
                        return _this.refreshToken();
                    case 7:
                        token = _ctx.sent;
                    case 8:
                        return _ctx.abrupt("return", token);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
    * Refresh the token.
    * 
    * @returns The new token. Undefined if unsuccessful.
    */ _proto.refreshToken = function refreshToken() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var token, refreshToken, ref, client, data;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        token = null;
                        refreshToken = localStorage.getItem(TokenManager.localStorageRefreshTokenIdentifier);
                        if (!(refreshToken != null)) {
                            _ctx.next = 9;
                            break;
                        }
                        ;
                        client = _this.createClient();
                        _ctx.next = 7;
                        return client.mutate({
                            mutation: _graphql_generated__WEBPACK_IMPORTED_MODULE_3__/* .RefreshUserTokenDocument */ .fD,
                            variables: {
                                refreshToken: refreshToken
                            }
                        });
                    case 7:
                        data = _ctx.sent.data;
                        if (data === null || data === void 0 ? void 0 : (ref = data.refreshToken) === null || ref === void 0 ? void 0 : ref.success) {
                            token = data.refreshToken.token;
                            // Save new tokens to the local storage.
                            _this.saveTokensToLocalStorage(data.refreshToken.token, data.refreshToken.refreshToken);
                        }
                    case 9:
                        return _ctx.abrupt("return", token);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Check if the JWT is expired.
     * 
     * @param jwt Decoded JWT.
     */ _proto.isJwtExpired = function isJwtExpired(jwt) {
        return Date.now() >= jwt.exp * 1000;
    };
    /**
     * Decode a JWT.
     * 
     * @param token JWT as a string.
     * @returns JWT as JSON
     */ _proto.parseJwt = function parseJwt(token) {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(jsonPayload);
    };
    /**
     * Save JWT and the refresh token to the local storage.
     * 
     * @param token 
     * @param refreshToken 
     */ _proto.saveTokensToLocalStorage = function saveTokensToLocalStorage(token, refreshToken) {
        localStorage.setItem(TokenManager.localStorageTokenIdentifier, token);
        localStorage.setItem(TokenManager.localStorageRefreshTokenIdentifier, refreshToken);
    };
    return TokenManager;
}();
TokenManager.localStorageTokenIdentifier = "token";
TokenManager.localStorageRefreshTokenIdentifier = "refreshToken";
/* harmony default export */ __webpack_exports__["Z"] = (TokenManager);


/***/ }),

/***/ 6939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export User */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2951);
/* harmony import */ var _swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5785);
/* harmony import */ var _swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2662);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6626);
/* harmony import */ var _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _graphql_apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8969);
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2705);
/* harmony import */ var _BusinessEntity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(628);











/**
 * Represents the Django AppUser class.
 */ var User = /*#__PURE__*/ function(BusinessEntity) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(User, BusinessEntity);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(User);
    function User() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, User);
        var _this;
        _this = _super.apply(this, arguments);
        _this.isStaff = false;
        _this.isActive = true;
        _this.firstName = "";
        _this.lastName = "";
        _this.nickname = "";
        _this.name = "";
        _this.facebookLoginId = "";
        _this.googleLoginId = "";
        return _this;
    }
    var _proto = User.prototype;
    // Override
    _proto.copyFromGraphQL = function copyFromGraphQL(graphQlObject) {
        (0,_swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(User.prototype), "copyFromGraphQL", this).call(this, graphQlObject);
        this.id = this.pk;
    };
    /**
     * Deactivate the user. Use this instead of deleting the account.
     */ _proto.deActivate = function deActivate() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this.isActive = false;
                        _ctx.next = 3;
                        return _this.save();
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Check the password for an user email.
     * 
     * @param email User email
     * @param password User password
     */ User.checkPassword = function checkPassword(email, password) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _graphql_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].query */ .Z.query({
                            query: _graphql_generated__WEBPACK_IMPORTED_MODULE_2__/* .CheckPasswordDocument */ .vg,
                            variables: {
                                email: email,
                                password: password
                            }
                        });
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data.checkPassword);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(User, [
        {
            key: "fullName",
            get: /**
     * The user's full name.
     */ function get() {
                if (this.name != "") {
                    return this.name;
                } else {
                    return this.firstName + " " + this.lastName;
                }
            }
        }
    ]);
    return User;
}(_BusinessEntity__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP);
User.createEntity = function() {
    return new User();
};
User.manager = new _BusinessEntity__WEBPACK_IMPORTED_MODULE_3__/* .EntityManager */ .v2({
    name: "UserNode",
    createEntity: User.createEntity,
    fields: [
        {
            name: "pk",
            isInput: false
        },
        {
            name: "username",
            isInput: false
        },
        {
            name: "email"
        },
        {
            name: "password",
            isInFieldDetails: false
        },
        {
            name: "verified",
            isInput: false
        },
        {
            name: "isStaff",
            isInput: false
        },
        {
            name: "isActive"
        },
        {
            name: "dateJoined",
            isInput: false
        },
        {
            name: "firstName"
        },
        {
            name: "lastName"
        },
        {
            name: "nickname"
        },
        {
            name: "name"
        },
        {
            name: "facebookLoginId",
            isInput: false,
            protectStringNumber: true
        },
        {
            name: "googleLoginId",
            isInput: false,
            protectStringNumber: true
        }, 
    ],
    graphQlQueryAlias: "users",
    graphQlSaveAlias: "saveUser",
    graphQlInputAlias: "UserInput",
    graphQlDeleteAlias: "deleteUser",
    hasTotalCount: false
});
/* harmony default export */ __webpack_exports__["Z"] = (User);


/***/ }),

/***/ 8658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EL": function() { return /* binding */ uniqueId; },
/* harmony export */   "Ri": function() { return /* binding */ isElementAboveThreshold; },
/* harmony export */   "Us": function() { return /* binding */ freshImageUrl; }
/* harmony export */ });
/* unused harmony exports shuffle, capitalizeFirstLetter, removeAccents, padNumber, replaceAll, copyToClipboard, objectToArray, base64toBlob, getRandomInt, numberFormat, formatDate, formatTime, formatDateTime, today, now, getCookie, setCookie, deleteCookie */
/**
* Shuffle an array.
* 
* @param array The array to shuffle.
*/ function shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    // While there remain elements to shuffle...
    while(0 !== currentIndex){
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}
/**
* Capitalize the first letter of a string.
* 
* @param string 
*/ function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
/**
* Removes the accents from the string.
* 
* @param string 
*/ function removeAccents(string) {
    return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
/**
* Pad the number with digits. Ex: 2 becomes 02.
* 
* @param n The number as string.
* @param width The width after padding.
* @param z The digit to use for padding. Default is 0.
*/ function padNumber(n, width) {
    var z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
    z = z || "0";
    n = n + "";
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}
/**
* Replace all occurences in a string. Case sensitive.
* 
* @param search 
* @param replace 
* @param subject 
*/ function replaceAll(search, replace, subject) {
    return subject.replace(new RegExp(search, "g"), replace);
}
/**
* Copy a string to the clipboard.
* 
* @param str 
*/ function copyToClipboard(str) {
    var el = document.createElement("textarea"); // Create a <textarea> element
    el.value = str; // Set its value to the string that you want copied
    el.setAttribute("readonly", ""); // Make it readonly to be tamper-proof
    el.style.position = "absolute";
    el.style.left = "-9999px"; // Move outside the screen to make it invisible
    document.body.appendChild(el); // Append the <textarea> element to the HTML document
    var selection = document.getSelection();
    if (selection != null) {
        var selected = selection.rangeCount > 0 // Check if there is any content selected previously
         ? selection.getRangeAt(0) // Store selection if found
         : false; // Mark as false to know no selection existed before
        el.select(); // Select the <textarea> content
        document.execCommand("copy"); // Copy - only works as a result of a user action (e.g. click events)
        document.body.removeChild(el); // Remove the <textarea> element
        selection = document.getSelection();
        if (selected && selection != null) {
            selection.removeAllRanges(); // Unselect everything on the HTML document
            selection.addRange(selected); // Restore the original selection
        }
    }
}
/**
* Converts an object to an array.
* 
* @param object 
*/ function objectToArray(object) {
    var array = [];
    var keys = Object.keys(object);
    keys.map(function(key) {
        array[key] = object[key];
    });
    return array;
}
/**
* Converts base64 to Blob.
* 
* @param base64 
* @param type 
*/ function base64toBlob(base64, type) {
    var byteString = atob(base64.split(",")[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for(var i = 0; i < byteString.length; i++){
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([
        ab
    ], {
        type: type
    });
}
/**
 * Generate a unique ID string.
 * 
 * @returns The unique ID.
 */ function uniqueId() {
    return Math.random().toString(36).substring(2, 9);
}
/**
 * Generate a random integer.
 * 
 * @param min 
 * @param max 
 * @returns The random int.
 */ function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
}
/**
 * Format a number.
 * https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
 * 
 * @param number 
 * @param decimals 
 * @param dec_point 
 * @param thousands_sep 
 * @returns 
 */ function numberFormat(number, decimals, dec_point, thousands_sep) {
    // http://kevin.vanzonneveld.net
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     bugfix by: Michael White (http://getsprink.com)
    // +     bugfix by: Benjamin Lupton
    // +     bugfix by: Allan Jensen (http://www.winternet.no)
    // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +     bugfix by: Howard Yeend
    // +    revised by: Luke Smith (http://lucassmith.name)
    // +     bugfix by: Diogo Resende
    // +     bugfix by: Rival
    // +      input by: Kheang Hok Chin (http://www.distantia.ca/)
    // +   improved by: davook
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Jay Klehr
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Amir Habibi (http://www.residence-mixte.com/)
    // +     bugfix by: Brett Zamir (http://brett-zamir.me)
    // +   improved by: Theriault
    // +   improved by: Drew Noakes
    // *     example 1: number_format(1234.56);
    // *     returns 1: '1,235'
    // *     example 2: number_format(1234.56, 2, ',', ' ');
    // *     returns 2: '1 234,56'
    // *     example 3: number_format(1234.5678, 2, '.', '');
    // *     returns 3: '1234.57'
    // *     example 4: number_format(67, 2, ',', '.');
    // *     returns 4: '67,00'
    // *     example 5: number_format(1000);
    // *     returns 5: '1,000'
    // *     example 6: number_format(67.311, 2);
    // *     returns 6: '67.31'
    // *     example 7: number_format(1000.55, 1);
    // *     returns 7: '1,000.6'
    // *     example 8: number_format(67000, 5, ',', '.');
    // *     returns 8: '67.000,00000'
    // *     example 9: number_format(0.9, 0);
    // *     returns 9: '1'
    // *    example 10: number_format('1.20', 2);
    // *    returns 10: '1.20'
    // *    example 11: number_format('1.20', 4);
    // *    returns 11: '1.2000'
    // *    example 12: number_format('1.2000', 3);
    // *    returns 12: '1.200'
    var n = !isFinite(+number) ? 0 : +number, prec = !isFinite(+decimals) ? 0 : Math.abs(decimals), sep = thousands_sep === undefined ? "," : thousands_sep, dec = dec_point === undefined ? "." : dec_point, toFixedFix = function toFixedFix(n, prec) {
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        var k = Math.pow(10, prec);
        return Math.round(n * k) / k;
    }, s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split(".");
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
        s[1] = s[1] || "";
        s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
}
/**
 * Calculates if the HTML element is above the lazy load threshold. Can be used while scrolling.
 * 
 * @param element The HTML element.
 * @param thresholdInPixels A distance in pixels to the bottom of the screen.
 */ function isElementAboveThreshold(element) {
    var thresholdInPixels = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    //the distance between the top of the window and the top of the image
    var imageTop = element.getBoundingClientRect().y;
    //the height of the window
    var windowHeight = window.innerHeight;
    //Normaly (if thresholdInPixels is 0) the image is above threshold if the top of the image is visible.
    var isAboveTreshold = imageTop <= windowHeight + thresholdInPixels;
    return isAboveTreshold;
}
/**
 * Return an image URL the forces image refresh in the browser.
 * 
 * @param imageUrl The URL of the image
 */ function freshImageUrl(imageUrl) {
    if (imageUrl != null) {
        var glue = imageUrl.indexOf("?") == -1 ? "?" : "&";
        return imageUrl + glue + Math.random();
    } else {
        return "";
    }
}
/**
 * Return the GMT date in YYYY-mm-dd format.
 * 
 * @param date A Date or a timestamp.
 * @returns 
 */ function formatDate(date) {
    var d = new Date(date);
    var month = "" + (d.getUTCMonth() + 1); // Need to add one because getMonth() is 0 based.
    var day = "" + d.getUTCDate();
    var year = d.getUTCFullYear();
    return [
        year,
        padNumber(month, 2),
        padNumber(day, 2)
    ].join("-");
}
/**
 * Return the GMT time in hh:mm:ss format.
 * 
 * @param date A Date or a timestamp.
 * @returns
 */ function formatTime(date) {
    var d = new Date(date);
    var hours = "" + d.getUTCHours();
    var minutes = "" + d.getUTCMinutes();
    var seconds = "" + d.getUTCSeconds();
    return [
        padNumber(hours, 2),
        padNumber(minutes, 2),
        padNumber(seconds, 2)
    ].join(":");
}
/**
 * Return the GMT datetime to YYYY-mm-dd hh:mm:ss
 * 
 * @param date A Date or a timestamp.
 * @returns
 */ function formatDateTime(date) {
    return formatDate(date) + " " + formatTime(date);
}
/**
* Get today's date in Y-m-d format.
*/ function today() {
    return formatDate(new Date());
}
/**
 * The current GMT date and time in YYYY-mm-dd hh:mm:ss format.
 */ function now() {
    return formatDateTime(new Date());
}
/**
* Get a cookie by name.
* 
* @param name Cookie name. 
*/ function getCookie(name) {
    name = name + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " "){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}
/**
* Set a cookie.
* 
* @param name 
* @param value 
* @param days 
*/ function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
/**
* Delete a cookie.
* 
* @param name 
*/ function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
}


/***/ }),

/***/ 7092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ getDataSourceDisplayMemberValue; },
  "tl": function() { return /* binding */ tl; }
});

// UNUSED EXPORTS: t

// EXTERNAL MODULE: ./redux/store.ts
var redux_store = __webpack_require__(4903);
;// CONCATENATED MODULE: ./res/json/translations.json
var translations_namespaceObject = JSON.parse('{"APP_TITLE":{"de":"CsakiArt","en":"CsakiArt","es":"CsakiArt","fr":"CsakiArt","hu":"CsakiArt","it":"CsakiArt","nl":"CsakiArt","pt":"CsakiArt","ro":"CsakiArt"},"APP_LANGUAGE":{"de":"DE","en":"EN","es":"Español","fr":"Français","hu":"Magyar","it":"Italiano","nl":"Nederlands","pt":"Português","ro":"Română"},"CONNECTION_ERROR":{"de":"Verbindungsfehler","en":"Connection error","es":"Error de conexión","fr":"Erreur de connexion","hu":"Hiba a kapcsolatban","it":"Errore di connessione","nl":"Verbindingsfout","pt":"Erro de conexão","ro":"Eroare de conexiune"},"SERVER_ERROR":{"de":"Serverfehler","en":"Server error","es":"Error del Servidor","fr":"Erreur du serveur","hu":"Szerver hiba","it":"Errore del server","nl":"Serverfout","pt":"Erro de servidor","ro":"Eroare de server"},"LOADING":{"de":"Wird geladen","en":"Loading","es":"Cargando","fr":"Chargement","hu":"Betöltés","it":"Caricamento in corso","nl":"Bezig met laden","pt":"Carregando","ro":"Se încarcă"},"LANGUAGE":{"de":"Sprache","en":"Language","es":"Idioma","fr":"Langue","hu":"Nyelv","it":"Lingua","nl":"Taal","pt":"Língua","ro":"Limbă"},"SITE_INFO":{"de":"Info","en":"Info","es":"Info","fr":"Info","hu":"Infó","it":"Info","nl":"Info","pt":"Info","ro":"Info"},"ABOUT_US":{"de":"Über uns","en":"About us","es":"Acerca de","fr":"À propos de nous","hu":"Rólunk","it":"Riguardo a noi","nl":"Over ons","pt":"Sobre nós","ro":"Despre noi"},"PRIVACY_POLICY":{"de":"Datenschutz","en":"Privacy policy","es":"Política de privacidad","fr":"Politique de confidentialité","hu":"Adatvédelem","it":"Politica sulla riservatezza","nl":"Privacybeleid","pt":"Política de Privacidade","ro":"Politica de confidențialitate"},"TERMS_AND_CONDITIONS":{"de":"Geschäftsbedingungen","en":"Terms and conditions","es":"Términos y condiciones","fr":"Termes et conditions","hu":"Felhasználási feltételek","it":"Termini e Condizioni","nl":"Algemene voorwaarden","pt":"Termos e Condições","ro":"Termeni și condiții"},"CONTACT":{"de":"Kontakt","en":"Contact","es":"Contacto","fr":"Contact","hu":"Kapcsolat","it":"Contatto","nl":"Contact","pt":"Contato","ro":"Contact"},"SHARE":{"de":"Teilen","en":"Share","es":"Compartir","fr":"Partager","hu":"Megosztás","it":"Condividi","nl":"Delen","pt":"Compartilhar","ro":"Share"},"GDPR_TEXT":{"en":"This website may use cookies to improve your experience.","de":"Wir verwenden Cookies, um die Benutzerfreundlichkeit unserer Website zu verbessern.","es":"Este sitio web usa Cookies para mejorar y optimizar la experiencia del usuario.","fr":"Ce site utilise des cookies pour améliorer votre expérience de navigation.","hu":"Ez az oldal a felhasználói élmény javítása érdekében sütiket használ.","it":"Utilizziamo i cookie per offrirti la miglior esperienza possibile.","nl":"Deze website maakt gebruik van cookies om u een optimale gebruikerservaring te bieden.","pt":"Usamos cookies para garantir a você a melhor experiência no nosso site.","ro":"Folosim cookies pentru a-ți oferi o experiență cât mai bună pe acest site."},"GDPR_ACCEPT":{"en":"Allow","de":"Gestatten","es":"Permitir","fr":"Autoriser","hu":"OK","it":"Permettere","nl":"Akkoord","pt":"Permitir","ro":"Permite"},"GDPR_DENY":{"en":"Do not allow","de":"Nicht gestatten","es":"Cerrar","fr":"Fermer","hu":"Becsuk","it":"Chiudi","nl":"Close","pt":"Fechar","ro":"Închide"},"404_OH_NO":{"de":"Ach nein!","en":"Oh no!","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"404_TITLE":{"de":"Seite nicht gefunden","en":"Page not found","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"404_DESCRIPTION":{"de":"Wir konnten die von Ihnen gesuchte Seite nicht finden.","en":"We couldn\'t find the page you are looking for.","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"404_GO_TO_HOME":{"de":"Zur Startseite gehen","en":"Go to home page","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"DASHBOARD":{"de":"","en":"Dashboard","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"MY_ACCOUNT":{"de":"","en":"My account","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":"Contul meu"},"SIGN_IN":{"de":"","en":"Sign in","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"SIGN_IN_DESC":{"de":"","en":"Enter your credentials to sign in.","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"EMAIL":{"de":"","en":"Email","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"PASSWORD":{"de":"","en":"Password","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"ENTER_YOUR_EMAIL_ADDRESS":{"de":"","en":"Enter your email address","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"ENTER_YOUR_PASSWORD":{"de":"","en":"Enter your password","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"SIGN_IN_NO_ACCOUNT":{"de":"","en":"Don\'t have an account?","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"SIGN_UP":{"de":"","en":"Sign up","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"HOME_META_DESC":{"de":"Poetry is what one must tell. That is valid for fine art as well: My graphics, paintings, everything I do is the thing I feel I must do.","en":"Poetry is what one must tell. That is valid for fine art as well: My graphics, paintings, everything I do is the thing I feel I must do.","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"LOGO_TEXT":{"de":"István Csáki","en":"István Csáki","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"ABOUT":{"de":"Über mich","en":"About","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"PORTFOLIO":{"de":"Portfolio","en":"Portfolio","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"BIOGRAPHY":{"de":"Biographie","en":"Biography","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"EXHIBITIONS":{"de":"Ausstellungen","en":"Exhibitions","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"FOOTER_COPYRIGHT":{"de":"Copyright 2023 István Csáki","en":"Copyright 2023 István Csáki","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"CONTACT_SECTION_2_TITLE":{"de":"Sie können mich auch hier finden:","en":"You can also find me here:","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"CONTACT_SECTION_2_DESC":{"de":"Hier können Sie direkt eine Nachricht an mich senden. <br/> Falls Sie einen Rückruf wünschen, dann nennen Sie mir bitte Ihre Telefonnummer.<br/>Ich werden Ihre Anfrage bald möglichst beantworten.","en":"Here you can send me a direct message. <br/> If you would like me to call you back, please give me your phone number. <br/> I will answer your inquiry as soon as possible.","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"CONTACT_SECTION_2_PRIVACY_POLICY_CTA":{"de":"Zur Datenschutzerklärung","en":"To the Privacy Policy","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"CONTACT_NAME":{"de":"Name","en":"Name","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"PLACEHOLDER_CONTACT_NAME":{"de":"Dein Name...","en":"Your Name...","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"CONTACT_EMAIL":{"de":"Email Adresse","en":"Email Address","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"PLACEHOLDER_CONTACT_EMAIL":{"de":"Deine Email Adresse...","en":"Your Email Address...","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"CONTACT_MESSAGE":{"de":"Nachricht","en":"Message","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"PLACEHOLDER_CONTACT_MESSAGE":{"de":"Deine Nachricht...","en":"Your Message...","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"CONTACT_SUBMIT":{"de":"Senden","en":"Submit","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"CONTACT_FORM_THANK_YOU":{"de":"Die E-Mail wurde gesendet.","en":"The e-mail has been sent.","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"IMPRESSUM":{"de":"Impressum","en":"Impressum","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"EXHIBITION_CATEGORY_LINKS_TITLE":{"de":"Ausstellungen","en":"Exhibition by year","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""},"":{"de":"","en":"","es":"","fr":"","hu":"","it":"","nl":"","pt":"","ro":""}}');
;// CONCATENATED MODULE: ./xFrame4/common/Utils.ts


/**
* Get the translation for a text.
* 
* @param key The key of the text to translate.
* @param language The translation language code (eg: en, hu, ro).
* @returns The translation for the language.
*/ function tl(key, language) {
    var translations = translations_namespaceObject;
    if (translations[key] !== undefined && translations[key][language] !== undefined) {
        return translations[key][language];
    } else {
        return key;
    }
}
/**
 * Get the translation for the app language (set in Redux).
 * 
 * @param key The key of the text to translate.
 * @returns The translation for the app language.
 */ function t(key) {
    return tl(key, store.getState().layout.language.code);
}
/**
 * Get the value for the dataSourceDisplayMember.
 * 
 * @param item The datasource item (row).
 * @param dataSourceDisplayMember The display member.
 * @returns 
 */ function getDataSourceDisplayMemberValue(item, dataSourceDisplayMember) {
    var displayValue;
    if (!dataSourceDisplayMember.includes(".")) {
        displayValue = item[dataSourceDisplayMember];
    } else {
        var memberObject = item;
        var fieldSplits = dataSourceDisplayMember.split(".");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fieldSplits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var fieldSplit = _step.value;
                memberObject = memberObject[fieldSplit];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (memberObject !== undefined) displayValue = memberObject;
    }
    return displayValue;
}


/***/ }),

/***/ 8611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qM": function() { return /* binding */ useTranslate; },
  "qo": function() { return /* binding */ useUpdateEntityFields; }
});

// UNUSED EXPORTS: useAuthUserLoginFromJWT, useLoad, useLoadAddEditForm, useLoadExternalScripts, useScreenWidth, useSetStateFromProp, useUpdateTranslationFields

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./redux/hooks.ts
var hooks = __webpack_require__(6410);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./redux/userSlice.ts
var userSlice = __webpack_require__(9355);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(2951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(6626);
// EXTERNAL MODULE: ./graphql/apollo-client.ts + 1 modules
var apollo_client = __webpack_require__(8969);
// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(2705);
// EXTERNAL MODULE: ./xFrame4/business/TokenManager.ts
var TokenManager = __webpack_require__(1953);
// EXTERNAL MODULE: ./xFrame4/business/User.ts
var User = __webpack_require__(6939);
;// CONCATENATED MODULE: ./xFrame4/business/AuthUser.ts










/**
 * Represents the authenticable user. Uses a JWT to authenticate.
 * After authentication we can make requests to the API based on the assigned Django permissions.
 * 
 * Based on https://django-graphql-auth.readthedocs.io/en/latest/.
 */ var AuthUser_AuthUser = /*#__PURE__*/ function(User1) {
    "use strict";
    (0,_inherits/* default */.Z)(AuthUser, User1);
    var _super = (0,_create_super/* default */.Z)(AuthUser);
    function AuthUser() {
        (0,_class_call_check/* default */.Z)(this, AuthUser);
        var _this;
        _this = _super.call(this);
        /** The JWTs in the local storage. */ _this.authInfo = {
            token: "",
            refreshToken: ""
        };
        return _this;
    }
    var _proto = AuthUser.prototype;
    /**
     * Get the JWT of the user from the local storage. 
     * If the token is outdated it will try to refresh the token via the GraphQL API.
     */ _proto.getToken = function getToken() {
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var tokenManager;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tokenManager = new TokenManager/* default */.Z();
                        _ctx.next = 3;
                        return tokenManager.getTokenFromLocalStorage();
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Register a user in the application. 
     * Logs in and assigns the registered user to the singleton object.
     * 
     * @param email User email address.
     * @param password Password.
     */ AuthUser.register = function register(email, password) {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return apollo_client/* default.mutate */.Z.mutate({
                            mutation: generated/* RegisterUserDocument */.E8,
                            variables: {
                                email: email,
                                password: password
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        if (!(data === null || data === void 0 ? void 0 : (ref = data.register) === null || ref === void 0 ? void 0 : ref.success)) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 7;
                        return _this.login(email, password);
                    case 7:
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref1 = data.register) === null || ref1 === void 0 ? void 0 : ref1.success);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Verify the registered user's email address after registration.
     * https://django-graphql-auth.readthedocs.io/en/latest/api/#verifyaccount
     * 
     * @param token The account verification token received after registratiom.
     */ AuthUser.verifyAccount = function verifyAccount(token) {
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return apollo_client/* default.mutate */.Z.mutate({
                            mutation: generated/* VerifyAccountDocument */.AT,
                            variables: {
                                token: token
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.verifyAccount) === null || ref === void 0 ? void 0 : ref.success);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Resend the account activation email to an email address.
     * https://django-graphql-auth.readthedocs.io/en/latest/api/#resendactivationemail
     * 
     * @param email The email of the registered user.
     */ AuthUser.resendActivationEmail = function resendActivationEmail(email) {
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return apollo_client/* default.mutate */.Z.mutate({
                            mutation: generated/* ResendActivationEmailDocument */.hu,
                            variables: {
                                email: email
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.resendActivationEmail) === null || ref === void 0 ? void 0 : ref.success);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Send a password reset email to an email address.
     * https://django-graphql-auth.readthedocs.io/en/latest/api/#sendpasswordresetemail
     * 
     * @param email The user's email address.
     */ AuthUser.sendPasswordResetEmail = function sendPasswordResetEmail(email) {
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return apollo_client/* default.mutate */.Z.mutate({
                            mutation: generated/* SendPasswordResetEmailDocument */.LU,
                            variables: {
                                email: email
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.sendPasswordResetEmail) === null || ref === void 0 ? void 0 : ref.success);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Change user password without old password, after receiving the password reset email.
     * https://django-graphql-auth.readthedocs.io/en/latest/api/#passwordreset
     * 
     * @param passwordResetToken The token received in the password reset email (sent with 'sendPasswordResetEmail').
     * @param newPassword1 The new password.
     * @param newPassword2 Confirm the new password.
     */ AuthUser.passwordReset = function passwordReset(passwordResetToken, newPassword1, newPassword2) {
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return apollo_client/* default.mutate */.Z.mutate({
                            mutation: generated/* PasswordResetDocument */.vK,
                            variables: {
                                token: passwordResetToken,
                                newPassword1: newPassword1,
                                newPassword2: newPassword2
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.passwordReset) === null || ref === void 0 ? void 0 : ref.success);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Authenticate a user with email and password.
     * Assigns the logged in user to the singleton object.
     * 
     * @param email 
     * @param password 
     * @returns True if login was successful.
     */ AuthUser.login = function login(email, password) {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, data, ref1, ref2, userAuthInfo, tokenManager;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return apollo_client/* default.mutate */.Z.mutate({
                            mutation: generated/* LoginUserDocument */.tV,
                            variables: {
                                email: email,
                                password: password
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        if (!(data === null || data === void 0 ? void 0 : (ref = data.tokenAuth) === null || ref === void 0 ? void 0 : ref.success)) {
                            _ctx.next = 14;
                            break;
                        }
                        ;
                        userAuthInfo = {
                            token: data === null || data === void 0 ? void 0 : (ref1 = data.tokenAuth) === null || ref1 === void 0 ? void 0 : ref1.token,
                            refreshToken: data === null || data === void 0 ? void 0 : (ref2 = data.tokenAuth) === null || ref2 === void 0 ? void 0 : ref2.refreshToken
                        };
                        tokenManager = new TokenManager/* default */.Z();
                        tokenManager.saveTokensToLocalStorage(userAuthInfo.token, userAuthInfo.refreshToken);
                        _this._current = AuthUser.createFromGraphQL(data.tokenAuth.user);
                        _this._current.authInfo = userAuthInfo;
                        return _ctx.abrupt("return", true);
                    case 14:
                        return _ctx.abrupt("return", false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Login or register a user with data received from the Facebook Login Javascript SDK.
     * https://developers.facebook.com/docs/facebook-login/web/
     * 
     * @param facebookLoginId The UserID received from Facebook.
     * @param email The email received from Facebook. It is not needed for login, but it's needed for registration.
     */ AuthUser.loginFacebookUser = function loginFacebookUser(facebookLoginId, email) {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, data, ref1, ref2, userAuthInfo, tokenManager;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return apollo_client/* default.mutate */.Z.mutate({
                            mutation: generated/* LoginFacebookUserDocument */.Cx,
                            variables: {
                                facebookLoginId: facebookLoginId,
                                email: email
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        if (!(data === null || data === void 0 ? void 0 : (ref = data.loginFacebookUser) === null || ref === void 0 ? void 0 : ref.success)) {
                            _ctx.next = 12;
                            break;
                        }
                        ;
                        userAuthInfo = {
                            token: data === null || data === void 0 ? void 0 : (ref1 = data.loginFacebookUser) === null || ref1 === void 0 ? void 0 : ref1.token,
                            refreshToken: data === null || data === void 0 ? void 0 : (ref2 = data.loginFacebookUser) === null || ref2 === void 0 ? void 0 : ref2.refreshToken
                        };
                        tokenManager = new TokenManager/* default */.Z();
                        tokenManager.saveTokensToLocalStorage(userAuthInfo.token, userAuthInfo.refreshToken);
                        _this._current = AuthUser.createFromGraphQL(data.loginFacebookUser.user);
                        _this._current.authInfo = userAuthInfo;
                        return _ctx.abrupt("return", true);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Login or register a user with data received from the Sign in with Google Javascript SDK.
     * https://developers.google.com/identity/gsi/web/guides/overview
     * 
     * @param googleLoginId The 'sub' from the Google ID token.
     * @param email The email from the Google ID token.
     */ AuthUser.loginGoogleUser = function loginGoogleUser(googleLoginId, email) {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, data, ref1, ref2, userAuthInfo, tokenManager;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return apollo_client/* default.mutate */.Z.mutate({
                            mutation: generated/* LoginGoogleUserDocument */.aL,
                            variables: {
                                googleLoginId: googleLoginId,
                                email: email
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        if (!(data === null || data === void 0 ? void 0 : (ref = data.loginGoogleUser) === null || ref === void 0 ? void 0 : ref.success)) {
                            _ctx.next = 12;
                            break;
                        }
                        ;
                        userAuthInfo = {
                            token: data === null || data === void 0 ? void 0 : (ref1 = data.loginGoogleUser) === null || ref1 === void 0 ? void 0 : ref1.token,
                            refreshToken: data === null || data === void 0 ? void 0 : (ref2 = data.loginGoogleUser) === null || ref2 === void 0 ? void 0 : ref2.refreshToken
                        };
                        tokenManager = new TokenManager/* default */.Z();
                        tokenManager.saveTokensToLocalStorage(userAuthInfo.token, userAuthInfo.refreshToken);
                        _this._current = AuthUser.createFromGraphQL(data.loginGoogleUser.user);
                        _this._current.authInfo = userAuthInfo;
                        return _ctx.abrupt("return", true);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Get the current authenticated user based on the saved JWT.
     * 
     * @returns The current authenticated user or null.
     */ AuthUser.loginFromJWT = function loginFromJWT() {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var tokenManager, token, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tokenManager = new TokenManager/* default */.Z();
                        _ctx.next = 3;
                        return tokenManager.getTokenFromLocalStorage();
                    case 3:
                        token = _ctx.sent;
                        if (!(token == null)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 6:
                        _ctx.next = 8;
                        return apollo_client/* default.query */.Z.query({
                            query: generated/* MeDocument */.en,
                            context: {
                                headers: {
                                    Authorization: "JWT " + token
                                }
                            }
                        });
                    case 8:
                        data = _ctx.sent.data;
                        if (!(data.me != null)) {
                            _ctx.next = 15;
                            break;
                        }
                        _this._current = AuthUser.createFromGraphQL(data.me);
                        _this._current.authInfo = {
                            token: localStorage.getItem(TokenManager/* default.localStorageTokenIdentifier */.Z.localStorageTokenIdentifier),
                            refreshToken: localStorage.getItem(TokenManager/* default.localStorageRefreshTokenIdentifier */.Z.localStorageRefreshTokenIdentifier)
                        };
                        return _ctx.abrupt("return", true);
                    case 15:
                        return _ctx.abrupt("return", false);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Log out the current authenticated user.
     */ AuthUser.logout = function logout() {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        localStorage.removeItem(TokenManager/* default.localStorageTokenIdentifier */.Z.localStorageTokenIdentifier);
                        localStorage.removeItem(TokenManager/* default.localStorageRefreshTokenIdentifier */.Z.localStorageRefreshTokenIdentifier);
                        _this._current = null;
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Verify the user JWT (is it still active?).
     */ AuthUser.verifyUserToken = function verifyUserToken() {
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, token, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        token = localStorage.getItem(TokenManager/* default.localStorageTokenIdentifier */.Z.localStorageTokenIdentifier);
                        if (!(token == null)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 4:
                        _ctx.next = 6;
                        return apollo_client/* default.mutate */.Z.mutate({
                            mutation: generated/* VerifyUserTokenDocument */.yh,
                            variables: {
                                token: token
                            }
                        });
                    case 6:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.verifyToken) === null || ref === void 0 ? void 0 : ref.success);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Deactivate the current authenticated user's account.
     * After deactivation the user cannot log in anymore.
     */ AuthUser.deactivateAccount = function deactivateAccount() {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, success;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return (ref = AuthUser.current) === null || ref === void 0 ? void 0 : ref.deActivate();
                    case 3:
                        success = _ctx.sent;
                        if (success) {
                            localStorage.removeItem(TokenManager/* default.localStorageTokenIdentifier */.Z.localStorageTokenIdentifier);
                            localStorage.removeItem(TokenManager/* default.localStorageRefreshTokenIdentifier */.Z.localStorageRefreshTokenIdentifier);
                            _this._current = null;
                        }
                        return _ctx.abrupt("return", success);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Change the current authenticated user's password.
     * 
     * @param oldPassword The old password.
     * @param newPassword The new password.
     * @returns True if successful.
     */ AuthUser.changePassword = function changePassword(oldPassword, newPassword) {
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!AuthUser.current) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 3;
                        return User/* default.checkPassword */.Z.checkPassword(AuthUser.current.email, oldPassword);
                    case 3:
                        if (!_ctx.sent) {
                            _ctx.next = 8;
                            break;
                        }
                        AuthUser.current.password = newPassword;
                        _ctx.next = 7;
                        return AuthUser.current.save();
                    case 7:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 8:
                        return _ctx.abrupt("return", false);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    (0,_create_class/* default */.Z)(AuthUser, null, [
        {
            key: "current",
            get: /**
     * Singleton.
     * 
     * @returns The current app user.
     */ function get() {
                // If there is no local storage or there is no token in the local storage: set singleton to null
                if (typeof localStorage == "undefined" || localStorage.getItem(TokenManager/* default.localStorageTokenIdentifier */.Z.localStorageTokenIdentifier) == null) this._current = null;
                return this._current;
            }
        }
    ]);
    return AuthUser;
}(User/* default */.Z);
/** Singleton. */ AuthUser_AuthUser._current = null;

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 12 modules
var Form = __webpack_require__(1358);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 4 modules
var Card = __webpack_require__(545);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js + 1 modules
var Button = __webpack_require__(3680);
// EXTERNAL MODULE: ./xFrame4/common/Utils.ts + 1 modules
var Utils = __webpack_require__(7092);
// EXTERNAL MODULE: ./redux/store.ts
var store = __webpack_require__(4903);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(1608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
;// CONCATENATED MODULE: ./xFrame4/components/admin/EntityPageTitle.tsx



var EntityPageTitle = function(props) {
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "page-title-box",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "page-title-right"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "page-title",
                            children: props.title
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var admin_EntityPageTitle = (EntityPageTitle);

;// CONCATENATED MODULE: ./xFrame4/components/admin/AddEditForm.tsx










var AddEditForm = function(props) {
    var t = useTranslate();
    var ref = (0,react.useState)(false), validated = ref[0], setValidated = ref[1];
    var ref1 = (0,react.useState)(false), isSaving = ref1[0], setIsSaving = ref1[1];
    var ref2 = (0,react.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    /** Save the form data. */ var save = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var success;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        success = false;
                        setIsSaving(true);
                        _ctx.prev = 2;
                        if (!props.onSave) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 6;
                        return props.onSave();
                    case 6:
                        success = _ctx.sent;
                    case 7:
                        setIsSaving(false);
                        if (props.afterSave && success) props.afterSave();
                        _ctx.next = 16;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                        setIsSaving(false);
                        setErrorMessage(_ctx.t0);
                    case 16:
                        if (success) close();
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    11
                ]
            ]);
        }));
        return function save() {
            return _ref.apply(this, arguments);
        };
    }();
    /** Close the form. */ var close = function() {
        if (props.onClose) props.onClose();
    };
    /** Form submit */ var onSubmit = function(event) {
        event.preventDefault();
        event.stopPropagation();
        // Validate
        var form = event.currentTarget;
        if (form.checkValidity() === true) {
            var isValid = true;
            if (props.onValidate !== undefined) isValid = props.onValidate(); // Additional custom validation
            // Form is valid: save
            if (isValid) save();
        }
        setValidated(true);
    };
    /** Title */ var title = "";
    if (props.title !== undefined) {
        title = props.title;
    } else {
        if (props.mode == AddEditForm_AddEditFormMode.Add && props.titleAdd) {
            title = props.titleAdd;
        } else if (props.mode == AddEditForm_AddEditFormMode.Edit && props.titleEdit) {
            title = props.titleEdit;
        }
    }
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "add-edit-form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(admin_EntityPageTitle, {
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                noValidate: true,
                validated: validated,
                onSubmit: function(event) {
                    return onSubmit(event);
                },
                className: "add-edit-form",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "header-title mb-3"
                            }),
                            props.children,
                            errorMessage != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "add-edit-error-message mt-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    role: "alert",
                                    className: "fade text-danger alert alert-danger show",
                                    children: errorMessage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex justify-content-end mt-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "secondary",
                                        onClick: function() {
                                            return close();
                                        },
                                        disabled: isSaving,
                                        className: "me-3",
                                        children: t("CANCEL")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "primary",
                                        type: "submit",
                                        disabled: isSaving,
                                        children: t("SAVE")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
AddEditForm.defaultProps = {
    titleAdd: (0,Utils.tl)("ADD", store/* store.getState */.h.getState().layout.language.code),
    titleEdit: (0,Utils.tl)("EDIT", store/* store.getState */.h.getState().layout.language.code)
};
var AddEditForm_AddEditFormMode;
(function(AddEditFormMode) {
    AddEditFormMode["Add"] = "add";
    AddEditFormMode["Edit"] = "edit";
})(AddEditForm_AddEditFormMode || (AddEditForm_AddEditFormMode = {}));
/* harmony default export */ var admin_AddEditForm = ((/* unused pure expression or super */ null && (AddEditForm)));

;// CONCATENATED MODULE: ./xFrame4/components/Hooks.ts









/**
 * Hook: translate a text to the selected app language from the Redux store.
 */ function useTranslate() {
    var appLanguage = (0,hooks/* useAppStateSelector */.k)(function(state) {
        return state.layout.language;
    });
    var t = function(text) {
        return (0,Utils.tl)(text, appLanguage.code);
    };
    return t;
}
/**
 * Hook: try to log in the user from the JWT in the local storage.
 * 
 * @param deps 
 * @returns 
 */ function useAuthUserLoginFromJWT(deps) {
    var ref = useState(true), isLoading = ref[0], setIsLoading = ref[1];
    var isUserLoggedIn = useAppStateSelector(function(state) {
        return state.user.isUserLoggedIn;
    });
    var dispatch = useAppActionDispatch();
    function loginFromJWT() {
        return _loginFromJWT.apply(this, arguments);
    }
    function _loginFromJWT() {
        _loginFromJWT = _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var success;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        if (isUserLoggedIn) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 4;
                        return AuthUser.loginFromJWT();
                    case 4:
                        success = _ctx.sent;
                        if (success && AuthUser.current != null) {
                            dispatch(setIsUserLoggedIn(success && AuthUser.current != null));
                        }
                    case 6:
                        setIsLoading(false);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _loginFromJWT.apply(this, arguments);
    }
    useEffect(function() {
        loginFromJWT();
    }, deps);
    return [
        isLoading,
        isUserLoggedIn
    ];
}
/**
* Hook: loads and executes external JS scripts. It's doing by adding the script to the body element.
* 
* @param scriptUrls The scripts that need to be executed.
* @param isEnabled Load the scripts or not? Needed, beacause hooks cannot be inside conditions.
* @param deps 
*/ function useLoadExternalScripts(scriptUrls, isEnabled, deps) {
    var scripts = [];
    useEffect(function() {
        if (isEnabled) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = scriptUrls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var scriptUrl = _step.value;
                    var script = document.createElement("script");
                    script.src = scriptUrl;
                    script.async = true;
                    document.body.appendChild(script);
                    scripts.push(script);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = scripts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var script = _step.value;
                        if (document.body.contains(script)) document.body.removeChild(script);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
        }
    }, deps);
}
/**
 * Hook: get the device screen width. Can be used along with Bootstrap breakpoints.
 * Do not use when SSR is involved.
 */ function useScreenWidth() {
    var ref = useState(window.innerWidth), screenWidth = ref[0], setScreenWidth = ref[1];
    useEffect(function() {
        setScreenWidth(window.innerWidth);
    }, [
        window.innerWidth
    ]);
    return screenWidth;
}
/**
 * Hook: copies the value of a component prop object to a component state object when the prop changes.
 * 
 * @param setter The setter function of the useState hook.
 * @prop prop An object from the component props.
 */ function useSetStateFromProp(setter, prop) {
    useEffect(function() {
        setter(prop);
    }, [
        prop
    ]);
}
/**
 * Hook: load data asynchronously.
 * 
 * @param loader An async function that loads the data.
 */ function useLoad(loader) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    useEffect(function() {
        loader();
    }, deps);
}
/**
 * Hook: create or load the entity for an AddEditForm.
 * 
 * @param entityClass The class of the entity (of type B)
 * @param mode The form mode.
 * @param entityId The ID of the entity (in case of edit)
 * @param setEntity The entity setter functin from useState.
 */ function useLoadAddEditForm(entityClass, mode, entityId, setEntity) {
    useLoad(_async_to_generator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(mode == AddEditFormMode.Add)) {
                        _ctx.next = 4;
                        break;
                    }
                    {
                        setEntity(new entityClass());
                    }
                    _ctx.next = 9;
                    break;
                case 4:
                    _ctx.t0 = setEntity;
                    _ctx.next = 7;
                    return entityClass.manager.get({
                        id: entityId
                    });
                case 7:
                    _ctx.t1 = _ctx.sent;
                    (0, _ctx.t0)(_ctx.t1);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
}
/**
 * Hook: update the fields of an entity.
 * 
 * @returns The entity, the entity setter and the field updater function.
 */ function useUpdateEntityFields() {
    // Set the entity
    var ref = (0,react.useState)(), entity = ref[0], setEntity = ref[1];
    // Update the field
    var updateEntityField = function(field, value) {
        if (entity !== undefined) {
            setEntity(function(prevEntity) {
                if (prevEntity !== undefined) {
                    var copy = prevEntity.copy();
                    copy[field] = value;
                    return copy;
                }
            });
        }
    };
    return [
        entity,
        setEntity,
        updateEntityField
    ];
}
/**
 * Hook: update the translation fields for an entity.
 */ function useUpdateTranslationFields() {
    var ref = useState(), translation = ref[0], setTranslation = ref[1];
    var updateTranslationField = function(field, value) {
        setTranslation(function(prev) {
            var copy = _object_spread({}, prev);
            copy[field] = value;
            return copy;
        });
    };
    return [
        translation,
        setTranslation,
        updateTranslationField
    ];
}


/***/ })

}]);